<template>
    <Navagation />
    <div>
        <title>Expense</title>
        <div>
            <h4 class="center-align">Expense</h4>
            <br>
            <div class="row">
                <form class="col s12" method="post" enctype="multipart/form-data">
                    <div class="row">
                        <div class="input-field col s6">
                            <textarea v-model="description" id="description" class="materialize-textarea"></textarea>
                            <label class="active" for="description">Description</label>
                        </div>
                        <div class="input-field col s6">
                            <select v-model="asset" id="asset">
                                <option value="" disabled selected>Choose your Asset</option>
                                <option value="14282 Greenview Drive">14282 Greenview Drive</option>
                                <option value="14275 Penn Dixie Lane">14275 Penn Dixie Lane</option>
                                <option value="861 Stouffer Avenue">861 Stouffer Avenue</option>
                                <option value="Dodge Ram 3500 Truck">Dodge Ram 3500 Truck</option>
                            </select>
                            <label>Asset</label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="input-field col s6">
                            <select v-model="category" id="category">
                                <option value="" disabled selected>Choose your Category</option>
                                <option value="School Tax">School Tax</option>
                                <option value="Property Tax">Property Tax</option>
                                <option value="Maintenance">Maintenance</option>
                                <option value="Insurance">Insurance</option>
                                <option value="Fuel">Fuel</option>
                            </select>
                            <label>Category</label>
                        </div>
                        <div class="input-field col s6">
                            <input v-model="amount" id="amount" type="text" class="validate">
                            <label class="active" for="amount">Amount</label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="input-field col s12">
                            <label class="active">Date</label>
                            <input v-model.lazy="date" type="text" class="datepicker">
                        </div>
                    </div>
                    <div class="row" v-if="image.length == 0">
                        <div class="file-field input-field col s12">
                            <div class="btn">
                                <span>File</span>
                                <input type="file" @change="onFileChange">
                            </div>
                            <div class="file-path-wrapper">
                                <input class="file-path validate" type="text">
                            </div>
                        </div>
                    </div>
                    <div class="row" v-if="image">
                        <div class="center-align">
                            <img class="responsive-img" :src="image" />
                        </div>
                        <div class="center-align">
                            <a v-if="!uploadURL" class="waves-effect waves-light btn" @click="removeImage">Remove</a>
                        </div>
                    </div>
                </form>
                <div class="row">
                    <div class="center-align">
                        <a class="waves-effect waves-light btn" @click="submit">Submit</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import M from 'materialize-css'
import axios from "axios"
import Navagation from '@/components/Navagation.vue';

/* ENTER YOUR ENDPOINT HERE */

const API_ENDPOINT = 'https://8c8gylju3m.execute-api.us-east-1.amazonaws.com/serverless_lambda_stage/'

export default {
    name: "App",
    components: { Navagation },
    data() {
        return {
            expense: null,
            ID: '',
            image: '',
            uploadURL: '',
            description: '',
            amount: '',
            asset: '',
            category: '',
            fileID: '',
            date: ''
        }
    },
    mounted() {
        M.AutoInit()
        let urlParams = new URLSearchParams(window.location.search);
        this.ID = urlParams.get('ID')
        console.log("Expense ID: " + this.ID)

        axios.get(API_ENDPOINT + "/expense/" + this.ID)
            .then(response => {
                this.expense = response.data;
                console.log(response.data);
                this.setter(response.data)
            });
    },
    methods: {
        setter: function (data) {
            this.description = data.description;
            this.amount = data.amount;
            // Set Asset
            var asset_elem = document.querySelector('#asset');
            var asset_instance = M.FormSelect.init(asset_elem);
            asset_instance.input.value = data.asset

            // Set Asset
            var category_elem = document.querySelector('#category');
            var category_instance = M.FormSelect.init(category_elem);
            category_instance.input.value = data.category

            //Set Image
            this.getImage(data.file)

            // Set Date
            var elems = document.querySelector('.datepicker');
            var date_instance = M.Datepicker.init(elems);
            date_instance.setDate(new Date(data.expense_date))
            this.date = data.expense_date

        },
        getImage: function (key) {
            // Create Pre-Signed URL
            axios.post(API_ENDPOINT + "/download", {
                key: key
            })
                .then(response => {
                    this.image = response.data.data
                });
        },
        removeImage: function () {
            this.image = ''
        }
    }
};
</script>
<style>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}
</style>